import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
import styles from "./css/index.css";
const eachClass = (domString, callback) => {
  var _context;
  _forEachInstanceProperty(_context = domString.split(/\s+/)).call(_context, callback);
};
var _classes = /*#__PURE__*/new _WeakMap();
var _eventTarget = /*#__PURE__*/new _WeakMap();
var _target = /*#__PURE__*/new _WeakMap();
var _tabClasses = /*#__PURE__*/new _WeakMap();
var _noTabClasses = /*#__PURE__*/new _WeakMap();
var _addClassToTarget = /*#__PURE__*/new _WeakMap();
var _removeClassFromTarget = /*#__PURE__*/new _WeakMap();
var _handleKey = /*#__PURE__*/new _WeakMap();
var _handleClick = /*#__PURE__*/new _WeakMap();
class TabAccessibility {
  constructor() {
    let {
      classes = styles,
      target = _globalThis.document.body,
      eventTarget = _globalThis
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classPrivateFieldInitSpec(this, _classes, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _eventTarget, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _target, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _tabClasses, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _noTabClasses, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _addClassToTarget, {
      writable: true,
      value: className => _classPrivateFieldGet(this, _target).classList.add(className)
    });
    _classPrivateFieldInitSpec(this, _removeClassFromTarget, {
      writable: true,
      value: className => _classPrivateFieldGet(this, _target).classList.remove(className)
    });
    _classPrivateFieldInitSpec(this, _handleKey, {
      writable: true,
      value: e => {
        if (e.keyCode === 9) {
          eachClass(_classPrivateFieldGet(this, _tabClasses), _classPrivateFieldGet(this, _addClassToTarget));
          eachClass(_classPrivateFieldGet(this, _noTabClasses), _classPrivateFieldGet(this, _removeClassFromTarget));
        }
      }
    });
    _classPrivateFieldInitSpec(this, _handleClick, {
      writable: true,
      value: () => {
        eachClass(_classPrivateFieldGet(this, _tabClasses), _classPrivateFieldGet(this, _removeClassFromTarget));
        eachClass(_classPrivateFieldGet(this, _noTabClasses), _classPrivateFieldGet(this, _addClassToTarget));
      }
    });
    _classPrivateFieldSet(this, _classes, typeof classes === 'function' ? classes(styles) : classes);
    _classPrivateFieldSet(this, _eventTarget, eventTarget);
    _classPrivateFieldSet(this, _target, target);
    _classPrivateFieldSet(this, _tabClasses, `${_classPrivateFieldGet(this, _classes).tab} Union__tab-accessibility__keyboard-interaction`);
    _classPrivateFieldSet(this, _noTabClasses, `${_classPrivateFieldGet(this, _classes)['no-tab']} Union__tab-accessibility__mouse-interaction`);
  }
  mount() {
    process.env.NODE_ENV !== 'production' ? console.warn("tab-accessibility is no longer necessary. keyboard outline is handled by `tk-ui-essentials`' resets") : void 0;
    _classPrivateFieldGet(this, _eventTarget).addEventListener('keydown', _classPrivateFieldGet(this, _handleKey));
    _classPrivateFieldGet(this, _eventTarget).addEventListener('mousedown', _classPrivateFieldGet(this, _handleClick));
    eachClass(_classPrivateFieldGet(this, _noTabClasses), _classPrivateFieldGet(this, _addClassToTarget));
  }
  unmount() {
    _classPrivateFieldGet(this, _eventTarget).removeEventListener('keydown', _classPrivateFieldGet(this, _handleKey));
    _classPrivateFieldGet(this, _eventTarget).removeEventListener('mousedown', _classPrivateFieldGet(this, _handleClick));
    eachClass(_classPrivateFieldGet(this, _tabClasses), _classPrivateFieldGet(this, _removeClassFromTarget));
    eachClass(_classPrivateFieldGet(this, _noTabClasses), _classPrivateFieldGet(this, _removeClassFromTarget));
  }
}
const create = function () {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return new TabAccessibility(...params);
};
export default create;